/** /zh/privacy — Chinese version. */
import { MarketingShell } from '../MarketingShell';

export function PrivacyZh() {
  return (
    <MarketingShell
      currentLocale="zh"
      hreflangPath="/privacy"
      documentTitle="Draftlize 的隐私 · Draftlize"
      documentDescription="我们收集什么、用它做什么、不做什么。人话版。绝不用你数据训练模型。cookie 只用于认证。按需 7 天内删除。"
    >
      <section className="hero" style={{ paddingTop: 88, paddingBottom: 64 }}>
        <div style={{ maxWidth: 820 }}>
          <span className="label label-amber">隐私</span>
          <h1 className="serif" style={{ fontSize: 'clamp(40px, 5vw, 64px)', lineHeight: 1, margin: '12px 0 24px' }}>
            隐私 <em>人话版。</em>
          </h1>
          <p className="lede">
            正式法律版每页底部 Terms / Privacy Policy 链接。这是人话版：我们实际收集什么、实际用它做什么、不做什么。
          </p>
        </div>
      </section>

      <section className="problem">
        <div className="head">
          <h2 className="serif">我们<em>收集的。</em></h2>
        </div>
        <div className="problem-grid">
          <div className="problem-col">
            <span className="num">I</span>
            <h3 className="serif">你的卡片、thread、refs</h3>
            <p>你创建的实际内容。存在你租户隔离的 Postgres + S3 桶里。仅你和你调用期间的 LLM 上游可见。</p>
          </div>
          <div className="problem-col">
            <span className="num">II</span>
            <h3 className="serif">账号基础</h3>
            <p>邮箱、OAuth provider ID（GitHub / Google）、显示名。仅此。不问职位、公司规模、其他。</p>
          </div>
          <div className="problem-col">
            <span className="num">III</span>
            <h3 className="serif">用于计费的用量事件</h3>
            <p>每次 LLM 调用的 token 成本（分），带时间戳，给 5 小时滚动 quota 窗用。只聚合——不是"你说了什么"，只是"你这个窗口用了 47 分"。</p>
          </div>
          <div className="problem-col">
            <span className="num">IV</span>
            <h3 className="serif">错误日志（匿名化）</h3>
            <p>如果你浏览器报错，我们记 stack trace + 你的 user_id + 请求 ID 用于排错。存我们自己 DB。无 PII 内容（你的卡片正文不在日志里）。</p>
          </div>
        </div>
      </section>

      <section className="problem" style={{ background: 'var(--paper-1)' }}>
        <div className="head">
          <h2 className="serif">我们<em>不</em>收集的。</h2>
        </div>
        <div className="problem-grid">
          <div className="problem-col">
            <span className="num">×</span>
            <h3 className="serif">营销分析</h3>
            <p>没 Google Analytics。没 Mixpanel。没第三方追踪像素。营销页零第三方脚本。</p>
          </div>
          <div className="problem-col">
            <span className="num">×</span>
            <h3 className="serif">跨站追踪</h3>
            <p>无第三方 cookie。我们设的 cookie 只有 session（认证）和 i18n locale 偏好。</p>
          </div>
          <div className="problem-col">
            <span className="num">×</span>
            <h3 className="serif">训练数据</h3>
            <p>我们不用你的数据训练模型。我们调用的 LLM provider（GLM、DeepSeek）都在不训练协议下。我们不把你的卡片喂进我们自己的训练管线——我们没有训练管线。</p>
          </div>
        </div>
      </section>

      <section className="problem">
        <div className="head">
          <h2 className="serif">你的<em>权利。</em></h2>
        </div>
        <div className="problem-grid">
          <div className="problem-col">
            <span className="num">I</span>
            <h3 className="serif">随时导出</h3>
            <p>Settings → Export。每个卡片、thread、document、history、ref 完整 markdown dump。纯文本。无私有格式。无摩擦。</p>
          </div>
          <div className="problem-col">
            <span className="num">II</span>
            <h3 className="serif">按需删除</h3>
            <p>邮件 <a href="mailto:hi@draftlize.com">hi@draftlize.com</a>。我们回复确认，你确认，我们删。7 天内。包括备份（下次备份周期擦受影响行）。完成后我们发确认。</p>
          </div>
          <div className="problem-col">
            <span className="num">III</span>
            <h3 className="serif">GDPR / CCPA 请求</h3>
            <p>同一邮箱。我们在两个法规要求的 30 天窗口内履行访问 / 可携 / 删除请求。</p>
          </div>
          <div className="problem-col">
            <span className="num">IV</span>
            <h3 className="serif">随时离开</h3>
            <p>没有订阅要取消——不想用就别再充值。你的数据随时可导出，账号也可以随时删除。</p>
          </div>
        </div>
      </section>

      <section className="pullquote">
        <blockquote className="serif">
          默认假设：你的卡片属于你。我们是你付钱让 substrate 跑起来的平台——不是想把你说的话变现的广告科技公司。
        </blockquote>
      </section>

      <section className="pricing" style={{ paddingTop: 80 }}>
        <div className="head">
          <h2 className="serif">隐私问题？<em>真人答。</em></h2>
        </div>
        <div style={{ textAlign: 'center', padding: '40px 24px', border: '1px solid var(--ink-0)', background: 'var(--paper-1)' }}>
          <p style={{ fontSize: 16, color: 'var(--ink-1)', margin: '0 0 24px', maxWidth: 640, marginLeft: 'auto', marginRight: 'auto' }}>
            <a href="mailto:hi@draftlize.com">hi@draftlize.com</a> 到我们。工作日 48 小时内真人回复。导出 / 删除 / GDPR 请求更快。
          </p>
          <a className="btn-primary" href="/">用 $5 免费开始</a>
        </div>
      </section>
    </MarketingShell>
  );
}
